"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({schedules, fn}) {
        this.state = {
            schedules: Array.isArray(schedules) && schedules.length ? schedules : [{
                    start: {},
                    end: {}
                }]
        };
        this.callbackFn = fn;
    },
    onAddMore: function () {
        this.state.schedules.push({
            start: {},
            end: {}
        });
        this.setStateDirty('schedules');
    },
    onRemove: function (index) {
        this.state.schedules.splice(index, 1);
        this.setStateDirty('schedules');
    },
    onChange: function (index, name, type, value) {
        this.state.schedules[index][name][type] = value;
        this.setStateDirty('schedules');
    },
    onDone: function () {
        const toReturn = this.state.schedules.filter(({start}) => {
            return !isEmpty(start);
        });
        typeof this.callbackFn == 'function' && this.callbackFn(toReturn);
        this.emit('done', toReturn);
        this.emit('dismiss');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/ScheduleForm/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    DateForm_template = require("./components/DateForm/index.marko"),
    DateForm_tag = marko_loadTag(DateForm_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "position-fixed top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("47e304"),
    marko_node0 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "11", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "pr-group"
      },
    marko_attrs2 = {
        "class": "position-absolute right-0 btn btn-icon rounded-circle border theme-bg",
        style: "margin-top:-33px"
      },
    marko_attrs3 = {
        "class": "col-md-6 col-3"
      },
    marko_attrs4 = {
        "class": "btn btn-secondary btn-lg mx-25"
      },
    marko_attrs5 = {
        "class": "col text-right"
      },
    marko_attrs6 = {
        "class": "btn btn-secondary btn-lg mx-25"
      },
    marko_attrs7 = {
        "class": "btn btn-primary btn-lg mx-25"
      };

require("~/../public/vendors/pickadate/js/picker");

require("~/../public/vendors/pickadate/js/picker.date");

require("~/../public/vendors/pickadate/js/picker.time");

require("~/../public/vendors/pickadate/js/legacy");

require("~/../public/vendors/pickadate/css/pickadate.css");

require("~/../public/vendors/pickadate/css/classic.css");

function render(input, out, __component, component, state) {
  var data = input;

  AutoScroll_tag({
      class: "position-absolute zindex-2 w-100 h-100 top-0 left-0 d-flex center",
      renderBody: function(out) {
        Row_tag({
            class: "m-0 w-100 d-flex justify-content-center",
            renderBody: function(out) {
              out.e("div", marko_attrs0, "2", component, 0, 0, {
                  onclick: __component.d("click", () => component.emit('dismiss'), false)
                });

              WSAdapt_tag({
                  ns: "col-md-4 col-10",
                  qs: "col-md-6 col-10",
                  hs: "col-md-8 col-10",
                  class: "animated zoomIn faster",
                  style: "padding-top:150px;padding-bottom:150px",
                  renderBody: function(out) {
                    out.be("h5", null, "4", component);

                    Locale_tag({
                        text: input.for.toCapitalCase() + " Schedules"
                      }, out, __component, "5");

                    out.ee();

                    out.n(marko_node0, component);

                    marko_forOf(state.schedules, function({ start, end }, index) {
                      var $keyValue$0 = "@" + index,
                          $keyScope$0 = "[" + ($keyValue$0 + "]");

                      out.be("div", marko_attrs1, $keyValue$0, component);

                      if (index > 0) {
                        out.e("hr", null, "7" + $keyScope$0, component, 0);

                        out.be("button", marko_attrs2, "8" + $keyScope$0, component, null, 0, {
                            onclick: __component.d("click", "onRemove", false, [
                                index
                              ])
                          });

                        Bx_tag({
                            type: "x",
                            class: "font-medium-3"
                          }, out, __component, "9" + $keyScope$0);

                        out.ee();
                      }

                      DateForm_tag({
                          start: start,
                          end: end,
                          idx: index
                        }, out, __component, "10" + $keyScope$0, [
                        [
                          "change",
                          "onChange",
                          false
                        ]
                      ]);

                      out.ee();
                    });

                    out.n(marko_node1, component);

                    Row_tag({
                        renderBody: function(out) {
                          out.be("div", marko_attrs3, "13", component);

                          out.be("button", marko_attrs4, "14", component, null, 0, {
                              onclick: __component.d("click", () => component.emit('dismiss'), false)
                            });

                          Locale_tag({
                              text: "Cancel"
                            }, out, __component, "15");

                          out.ee();

                          out.ee();

                          out.be("div", marko_attrs5, "16", component);

                          out.be("button", marko_attrs6, "17", component, null, 0, {
                              onclick: __component.d("click", "onAddMore", false)
                            });

                          Locale_tag({
                              text: "Add"
                            }, out, __component, "18");

                          out.ee();

                          if ( state.schedules.filter( ({ start }) => { return !isEmpty( start ) } ).length ) {
                            out.be("button", marko_attrs7, "19", component, null, 0, {
                                onclick: __component.d("click", "onDone", false)
                              });

                            Locale_tag({
                                text: "Done"
                              }, out, __component, "20");

                            out.ee();
                          }

                          out.ee();
                        }
                      }, out, __component, "12");
                  }
                }, out, __component, "3");
            }
          }, out, __component, "1");
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
